module.exports = __webpack_public_path__ + "static/img/icon-menu2.56298588.svg";